import "./App.css";
import "./vokietis.css";
import "./Components/PrimaryTextField/PrimaryTextField.css";
import "./Components/CheckBox/CheckBox.css";
import "./Navigation/NavBar.css";
import "./Components/Css/login.css";
import "./Components/Css/user.css";
import "./Components/Css/proflisPrideti.css";
import "./Components/Css/Formos.css";
import "./Components/Css/rezTend.css";
import "./Components/Css/policies.css";
// import './Components/Css/apklausaVidus.css';
import "./Components/PrimaryAccordion/PrimaryAccordion.css";
import "./Components/Css/Paulius.css";
import "./Components/statistikaTable.css";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { setupCorsErrorHandler, checkCorsConfiguration } from './utils/corsErrorHandler';
import "./Language/i18n";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Navigation from "./Navigation/NavigationBar";
import { BrowserRouter, useLocation } from "react-router-dom";
import TaskContextProvider, { GlobalStates } from "./GlobalStates";
import { Cookie } from "./clases/CookieClass";
import Toasty from "./Components/Alert/toasty-alert";
import ErrorBoundary from "./Components/ErrorBoundary";
import i18n from "./Language/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./muiTheme";
import AppRoutes from "./Navigation/Routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - much longer to prevent unnecessary refetches
      cacheTime: 10 * 60 * 1000, // 10 minutes - keep data in cache longer
      refetchOnWindowFocus: false,
      refetchOnMount: false, // Don't refetch unless data is stale
      refetchOnReconnect: 'always', // Still refetch on network reconnect
      retry: 2, // Reduce retries for faster failure feedback
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

// Simple import for the Routes component

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV !== "production" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
      <TaskContextProvider>
        <ThemeProvider theme={theme}>
          <Main />
        </ThemeProvider>
      </TaskContextProvider>
    </QueryClientProvider>
  );
}

const Main = () => {
  const kalba = useMemo(() => new Cookie("kalbai"), []);

  const { user, userStatus, setType, alert, isLoading } =
    useContext(GlobalStates);

  useEffect(() => {
    if (kalba.getCookie()) {
      i18n.changeLanguage(kalba.getCookie());
    }
  }, [kalba]);

  useEffect(() => {
    if (user !== null) {
      // User is logged in
      const isAdmin = userStatus?.admin_confirmed === true;
      setType(isAdmin ? "Admin" : "User");
    } else {
      // User is logged out or null
      setType("Guest");
    }
  }, [user, userStatus, setType]);

  // State to track if visibility change is happening (tab switching)
  const [isTabSwitching, setIsTabSwitching] = useState(false);

  // Initialize tab and filter synchronization on component mount
  useEffect(() => {
    // Initialize CORS error handler
    setupCorsErrorHandler();
    
    // Check CORS configuration on startup
    checkCorsConfiguration().then(result => {
      if (!result.corsEnabled) {
        console.error('CORS Configuration Error:', result);
      }
    });
    
  }, []);

  // Handle visibility change (tab switching)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setIsTabSwitching(true);
        // When tab becomes visible, remove loading spinner after a small delay
        setTimeout(() => {
          document.documentElement.classList.remove("auth-loading");
          setIsTabSwitching(false);
        }, 300);
      }
    };

    // Add visibility change listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Effect for handling loading state
  useEffect(() => {
    if (!isLoading) {
      // Not loading - remove spinner
      document.documentElement.classList.remove("auth-loading");

    } else if (!isTabSwitching) {
      // Only add loading class if not tab switching
      document.documentElement.classList.add("auth-loading");
    }
  }, [isLoading, isTabSwitching]);

  if (isLoading) {
    // We keep the simple text indicator here, as the primary visual
    // indicator is now handled by the CSS and class on <html>
    // return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Kraunasi...</div>;
    // Return null or an empty fragment while the initial HTML spinner is shown
    return null;
  }

  // When isLoading is false, the 'auth-loading' class is removed by the useEffect above,
  // hiding the initial spinner, and the main app content is rendered.
  return (
    <BrowserRouter>
      <AppContent alert={alert} />
    </BrowserRouter>
  );
};

// Separate component to access useLocation inside BrowserRouter
const AppContent = ({ alert }) => {
  const location = useLocation();
  
  // Check if we're on password reset pages
  const isPasswordResetPage = 
    location.pathname === '/NaujasSlaptazodis' || 
    location.pathname === '/PrimintiSlaptazodi' ||
    location.pathname === '/auth/recovery' ||
    location.pathname === '/email-confirmation';

  return (
    <div>
      {!isPasswordResetPage && (
        <div className="Navigacija">
          <Navigation />
        </div>
      )}
      <Toasty text={alert} />
      <div>
        <ErrorBoundary>
          <div key="routes-wrapper">
            <AppRoutes />
          </div>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default App;
